module.exports = __webpack_public_path__ + "img/pg.4e87aeb.svg";